import motivosImage from '../../../assets/img/artigos/motivos_icon.svg';
import sinaisImage from '../../../assets/img/artigos/sinais_icon.svg';

const violenceArticlesData = [
  {
    // C5
    id: 'por-que-essas-relacoes-de-violencia-perduram',
    href: '/artigos/por-que-essas-relacoes-de-violencia-perduram',
    title: 'Por que essas relações de violência perduram?',
    type: 'Violência contra a mulher',
    image: motivosImage,
    iconRef: 'motivos',
    text: (
      <>
        <p>
          <b>1. O maior de todos os riscos é romper a relação:</b> Muitos desses agressores são
          extremamente possessivos, encaram mulheres como um objeto de posse, então é muito comum
          que ao tentar pôr um fim à relação, essas mulheres sejam vitimizadas; vemos várias
          notícias de feminicídios decorrentes de tentativas de término. Então, muitas delas têm
          medo de acabar o relacionamento e sofrerem um dano maior;
        </p>
        <p>
          <b>2. Procurar ajuda é visto como vergonha e gera muito medo:</b> Muitas vezes as mulheres
          são muito julgadas pela violência que elas sofrem, como se fosse culpa delas. Existem
          muitos casos em que a mulher pede ajuda em delegacias e acaba sofrendo violência
          institucional “o que você fez pra ter sofrido essa violência?”. Exemplo disso é o caso da
          Mari Ferrer. Ou então o próprio medo delas serem julgadas pelo conceito que elas têm do
          papel delas, pois muitas mulheres acreditam que são exclusivamente responsáveis pela
          estabilidade da família, por conta de algo que a própria sociedade colocou na cabeça
          delas; A revitimização. Pode acontecer na fala de vizinhos, familiares e às vezes até
          mesmo de profissionais de segurança pública despreparados;
        </p>
        <p>
          <b>3. Sempre resta a esperança de que o marido mude o comportamento:</b> Na fase de
          lua-de-mel, como vimos, ele sempre se justifica dizendo que a ama, que vai mudar, que vai
          cuidar da família. Então ela acredita, pois é uma relação afetiva, não podemos esquecer
          que tem sentimento envolvido, então a vítima quer acreditar no homem que ela ama;
        </p>
        <p>
          <b>4. A vítima muitas vezes está isolada de sua rede de apoio:</b> A gente tem que lembrar
          que a violência que antecede todas as outras é a violência psicológica e, por meio dessa
          violência, o agressor isola a vítima, para que ela não tenha a quem recorrer para pedir
          ajuda, para que ela seja só dele. Para que ela não tenha a seu redor pessoas que o
          critiquem, que deem opiniões contrárias a dele ou que façam com que ela reflite sobre a
          situação que está vivendo;
        </p>
        <p>
          <b>5. Nossa sociedade ainda está despreparada para lidar com esse tipo de violência:</b>
          Existe violência institucional. Por determinação da Lei Maria da Penha existe a Casa da
          Mulher Brasileira, especializada no atendimento das mulheres, para evitar essa vitimização
          secundária. Mesmo assim, os órgãos não estão tão preparados para lidar com esse
          atendimento, por isso precisamos buscar a melhoria do sistema brasileiro;
        </p>
        <p>
          <b>6. Concretamente, muitos obstáculos impedem o rompimento:</b> Acreditam que os filhos,
          por exemplo, precisam de um pai, sentem-se responsáveis por manter a família unida,
          religião impede que elas se separem dos maridos, dependência econômica (muitas vezes os
          parceiros impedem que elas estudem ou trabalhem para manter a relação de dependência);
        </p>
        <p>
          <b>7. Algumas mulheres dependem economicamente de seus parceiros violentos; </b>
        </p>
        <p>
          <b>8. Deixar uma relação violenta é um processo. Cada uma tem seu tempo:</b> Devemos
          lembrar que muitas delas têm filhos, ligação sentimental, influência da família e amigos,
          religião, crença do papel delas na família. Cada uma tem seu tempo de tomar coragem para
          tomar uma atitude. E nós como terceiros precisamos entender e respeitar o tempo da mulher;
        </p>
        <p>
          <b>9. A questão do tempo do relacionamento - Etarismo:</b> É comum que as mulheres mais
          velhas sopesem isso no momento de decidir pelo fim; elas vão levar em consideração que o
          relacionamento já dura o bastante para não terminar, que elas estão “velhas demais” para
          saírem da relação e ficarem sozinhas/expostas na sociedade; pode ocorrer de o próprio
          agressor estimular essa crença na vítima;
        </p>
        <p>
          <b>10. Não consegue enxergar que está vivendo uma relação de violência:</b> Como já
          mencionado anteriormente, nós vivemos em uma sociedade em que o machismo está enraizado e
          em decorrência disso muitas mulheres sequer sabem que vivem em uma situação de violência,
          pois a vida todas estiveram inserida naquele meio( seja porque cresceram vendo sua mãe
          sendo violentada e entenderam aquilo como sendo algo normal) ou porque, infelizmente,
          estão tão imersas nesse pensamento machista ao ponto que não conseguem perceber que elas
          não merecem viver assim;
        </p>
        <p>
          Sair de uma relação violenta é um processo complexo, e cada mulher tem seu próprio tempo.
          É fundamental lembrar que muitas enfrentam obstáculos como ameaças aos seus filhos, laços
          sentimentais, pressões familiares e religiosas, além de uma sociedade que,
          lamentavelmente, ainda resiste em oferecer o apoio necessário, culpando a vítima pelo que
          ela sofre.
        </p>
      </>
    ),
  },
  {
    // C6
    id: 'sinais-de-violencia-domestica',
    href: '/artigos/sinais-de-violencia-domestica',
    title: 'Sinais de que a mulher está sofrendo violência doméstica',
    type: 'Violência contra a mulher',
    image: sinaisImage,
    iconRef: 'sinais',
    text: (
      <>
        <p>
          A escuta acolhedora é indispensável quando nos deparamos com uma mulher que está sendo
          submetida à violência doméstica e familiar, mas muitas vezes a escuta vai além do que é
          dito. Precisamos estar atentos a sinais e comportamentos que fogem do normal para mulheres
          do nosso convívio. A seguir, destacamos alguns desses indícios:
        </p>
        <p>
          <b>1. Vive aterrorizada:</b> Reflexos da violência psicológica que ela sofre, se sente
          perseguida. Ex: Marta conseguiu independência e se mudou para outro Município, mas ainda
          tinha medo do agressor aparecer onde ela estava para lhe fazer algum mal. As crianças
          também tinham medo. Ela viveu aterrorizada, pisando em ovos;
        </p>
        <p>
          <b>2. Isolou-se dos familiares e amigos por</b> vergonha de admitir que estava sofrendo
          violência doméstica. Uma mulher conhecida como empoderada, por exemplo, tem muita
          dificuldade para admitir isso. Imaginem, uma mulher na condição de vítima de violência tem
          seu ciclo de amizade limitado aos amigos comuns com o agressor. Ela dificilmente vai se
          sentir à vontade para compartilhar qualquer tipo de relato porque teme ser desacreditada
          ou até mesmo despertar a ira do agressor;
        </p>
        <p>
          <b>3. Perdeu a liberdade de ir aonde quer, de trabalhar de estudar:</b> “Meu marido falou
          que…”, “meu marido não gosta”, “meu marido não deixa…”;
        </p>
        <p>
          <b>4. Sente-se o tempo todo humilhada e desqualificada:</b> Consequências da violência
          psicológica, uma mulher que todo dia ouve que é burra, feia, incapaz, que não é nada. A
          autoestima fica abalada inevitavelmente;
        </p>
        <p>
          <b>5. Vive pisando em ovos para não despertar a ira:</b> Fase da explosão, vive com medo
          do que ele vai fazer e de como vai reagir;
        </p>
        <p>
          <b>6. Totalmente dependente dos ganhos do marido:</b> Às vezes a mulher decide ser dona do
          lar e não trabalhar por opção própria. Outras vezes ela é dona de casa por coação, por
          pressão do companheiro para que ela não se torne independente;
        </p>
        <p>
          <b>7. Perdeu a autoestima e está destruída psicologicamente:</b> Sinais como marcas no
          corpo da mulher. Mulher que aparece com bens de menor qualidade, com roupas que parecem
          cobri-la mais do que destacá-la.
        </p>
      </>
    ),
  },
];

export default violenceArticlesData;
